import { actionTypes } from 'src/views/pages/system-admin/user-search';
import { IUser } from '../utils/interfaces/user';
import { legacy_createStore } from 'redux';
import { Types } from 'src/views/pages/system-admin/dealer-security-maintenance';

import {
    ACCESS_USER_NAME,
    ASSOCIATIONS_NAME,
    COGNITO_TOKEN_NAME,
    DEALER_COUNTRY_NAME,
    DEFAULTDEALER_NAME,
    DISTRICTS_NAME,
    FULL_NAME,
    GET_DEALER_GROUP_STATE,
    PARTYID_NAME,
    PERMISSIONS_TOKEN_NAME,
    SELECTED_DISTRICT,
    USER_NAME,
} from '../config';
import {
    CREDIT,
    CREDIT_FORM_TOUCH_ACTIONS,
    DEALER_ADMIN,
    MODAL_CONTROL_ACTIONS,
    PAYMENTS,
    USER_ACTIONS,
} from '../utils/enums/user-store-actions.enum';

export const initialState: IUser = {
    isAuth: false,
    isMfaRegistered: false,
    isDeviceRemembered: false,
    secretUri: '',
    isLocked: false,
    cognitoToken: sessionStorage.getItem(COGNITO_TOKEN_NAME) || '',
    dealerCountry: sessionStorage.getItem(DEALER_COUNTRY_NAME) || null,
    isMfaTokenValid: false,
    username: sessionStorage.getItem(USER_NAME) || '',
    fullName: sessionStorage.getItem(FULL_NAME) || '',
    password: '',
    permissionsToken: sessionStorage.getItem(PERMISSIONS_TOKEN_NAME) || '',
    currentDealers: {
        default: sessionStorage.getItem(DEFAULTDEALER_NAME) || '',
        dealers: JSON.parse(sessionStorage.getItem(ASSOCIATIONS_NAME) || '[]'),
    },
    dealerDataInfo: undefined,
    accessUser: JSON.parse(sessionStorage.getItem(ACCESS_USER_NAME) || 'false'),
    districs: JSON.parse(sessionStorage.getItem(DISTRICTS_NAME) || '[]'),
    selectedDistrics: JSON.parse(
        sessionStorage.getItem(SELECTED_DISTRICT) || 'null',
    ),
    dialogModal: {
        isModalActive: false,
        shouldShow: false,
        titleContent: '',
        bodyContent: '',
        cancelBtnLabel: '',
        confirmBtnLabel: '',
        onCancelHandler: () => false,
        onConfirmHandler: () => false,
    },
    isCreditFormTouched: false,
    dsmSearch: {
        searchType: Types.UserId,
        searchValue: '',
        users: [],
        selectedUsers: [],
        actionType: '',
    },
    dealerGroupState: JSON.parse(
        sessionStorage.getItem(GET_DEALER_GROUP_STATE) || '[]',
    ),
    partyId: sessionStorage.getItem(PARTYID_NAME) || '',
};

const userReducer = (
    state = initialState,
    action: { type: string; payload?: any } = { type: '' },
) => {
    switch (action.type) {
        case USER_ACTIONS.SET_BLOCKED:
            return {
                isAuth: false,
                isMfaRegistered: false,
                isDeviceRemembered: false,
                secretUri: '',
                isLocked: action.payload,
                cognitoToken: '',
                dealerCountry: state.dealerCountry,
                isMfaTokenValid: false,
                username: '',
                fullName: '',
                password: '',
                permissionsToken: '',
                currentDealers: undefined,
                dealerDataInfo: undefined,
                dialogModal: getDialog(state),
                isCreditFormTouched: false,
                dsmSearch: {
                    searchType: Types.UserId,
                    searchValue: '',
                    users: [],
                },
                partyId: '',
            };
        case USER_ACTIONS.REMEMBERED:
            return {
                isAuth: true,
                isMfaRegistered: false,
                isDeviceRemembered: true,
                secretUri: '',
                isLocked: false,
                cognitoToken: action.payload.cognitoToken,
                dealerCountry: action.payload.dealerCountry,
                isMfaTokenValid: false,
                username: action.payload.username,
                fullName: action.payload.fullName,
                password: action.payload.password,
                permissionsToken: action.payload.permissionsToken,
                currentDealers: undefined,
                dealerDataInfo: undefined,
                dialogModal: getDialog(state),
                accessUser: action.payload.accessUser,
                districs: action.payload.districs,
                isCreditFormTouched: false,
                dsmSearch: {
                    searchType: Types.UserId,
                    searchValue: '',
                    users: [],
                },
                partyId: action.payload.partyId,
            };
        case USER_ACTIONS.MFA_REGISTERED:
            return {
                isAuth: true,
                isMfaRegistered: true,
                isDeviceRemembered: false,
                secretUri: '',
                isLocked: false,
                cognitoToken: '',
                dealerCountry: state.dealerCountry,
                isMfaTokenValid: false,
                username: action.payload.username,
                fullName: '',
                password: action.payload.password,
                permissionsToken: '',
                currentDealers: undefined,
                dealerDataInfo: undefined,
                dialogModal: getDialog(state),
                accessUser: action.payload.accessUser,
                districs: action.payload.districs,
                isCreditFormTouched: false,
                dsmSearch: {
                    searchType: Types.UserId,
                    searchValue: '',
                    users: [],
                },
            };
        case USER_ACTIONS.MFA_UNREGISTERED:
            return {
                isAuth: true,
                isMfaRegistered: false,
                isDeviceRemembered: false,
                secretUri: action.payload.secretUri,
                isLocked: false,
                cognitoToken: state.cognitoToken,
                dealerCountry: state.dealerCountry,
                isMfaTokenValid: false,
                username: action.payload.username,
                fullName: '',
                password: action.payload.password,
                permissionsToken: '',
                currentDealers: undefined,
                dealerDataInfo: undefined,
                dialogModal: getDialog(state),
                accessUser: action.payload.accessUser,
                districs: action.payload.districs,
                isCreditFormTouched: false,
                dsmSearch: {
                    searchType: Types.UserId,
                    searchValue: '',
                    users: [],
                },
            };
        case USER_ACTIONS.MFA_TOKEN_VALID:
            return {
                isAuth: state.isAuth,
                isMfaRegistered: state.isMfaRegistered,
                isDeviceRemembered: state.isDeviceRemembered,
                secretUri: state.secretUri,
                isLocked: state.isLocked,
                cognitoToken: action.payload.cognitoToken,
                dealerCountry: action.payload.dealerCountry,
                isMfaTokenValid: true,
                username: state.username,
                fullName: action.payload.fullName,
                password: state.password,
                permissionsToken: action.payload.permissionsToken,
                currentDealers: undefined,
                dealerDataInfo: undefined,
                dialogModal: getDialog(state),
                accessUser: action.payload.accessUser,
                districs: action.payload.districs,
                isCreditFormTouched: false,
                dsmSearch: {
                    searchType: Types.UserId,
                    searchValue: '',
                    users: [],
                },
                partyId: action.payload.partyId,
            };
        case USER_ACTIONS.SET_TOKEN:
            return {
                ...state,
                isAuth: state.isAuth,
                isMfaRegistered: state.isMfaRegistered,
                isDeviceRemembered: state.isDeviceRemembered,
                secretUri: state.secretUri,
                isLocked: state.isLocked,
                cognitoToken: action.payload.cognitoToken,
                isMfaTokenValid: state.isMfaTokenValid,
                username: state.username,
                fullName: state.fullName,
                password: state.password,
                permissionsToken: action.payload.permissionsToken,
                currentDealers: state.currentDealers,
                dealerDataInfo: state.dealerDataInfo,
                dialogModal: getDialog(state),
                accessUser: action.payload.accessUser || state.accessUser,
                districs: action.payload.districs || state.districs,
                selectedDistrics: state.selectedDistrics,
            };
        case USER_ACTIONS.SET_DEALERS:
            return {
                ...state,
                currentDealers: action.payload,
            };
        case USER_ACTIONS.SET_DEFAULT_DEALER:
            return {
                ...state,
                currentDealers: {
                    ...state.currentDealers,
                    default: action.payload,
                },
            };
        case USER_ACTIONS.SET_DEFAULT_DISTRICT:
            sessionStorage.setItem(SELECTED_DISTRICT, action.payload);
            sessionStorage.setItem(DEFAULTDEALER_NAME, '');
            return {
                ...state,
                selectedDistrics: action.payload,
                currentDealers: {
                    default: '',
                    dealers: [],
                },
            };
        case USER_ACTIONS.SET_DEALER_DATA:
            return {
                ...state,
                dealerDataInfo: action.payload,
            };
        case USER_ACTIONS.LOGOUT:
            return initialState;
        case MODAL_CONTROL_ACTIONS.SET_ACTIVE:
            return {
                ...state,
                dialogModal: {
                    isModalActive: true,
                    shouldShow: false,
                    titleContent: action.payload.titleContent,
                    bodyContent: action.payload.bodyContent,
                    cancelBtnLabel: action.payload.cancelBtnLabel,
                    confirmBtnLabel: action.payload.confirmBtnLabel,
                    onCancelHandler: action.payload.onCancelHandler,
                    onConfirmHandler: action.payload.onConfirmHandler,
                },
            };
        case MODAL_CONTROL_ACTIONS.SET_INACTIVE:
            return {
                ...state,
                dialogModal: {
                    isModalActive: false,
                    shouldShow: false,
                    titleContent: '',
                    bodyContent: '',
                    cancelBtnLabel: '',
                    confirmBtnLabel: '',
                    onCancelHandler: () => false,
                    onConfirmHandler: () => false,
                },
            };
        case MODAL_CONTROL_ACTIONS.SET_SHOW:
            return {
                ...state,
                dialogModal: {
                    isModalActive: state.dialogModal.isModalActive,
                    shouldShow: action.payload.shouldShow,
                    titleContent: state.dialogModal.titleContent,
                    bodyContent: state.dialogModal.bodyContent,
                    cancelBtnLabel: state.dialogModal.cancelBtnLabel,
                    confirmBtnLabel: state.dialogModal.confirmBtnLabel,
                    onCancelHandler: action.payload.onCancelHandler
                        ? action.payload.onCancelHandler
                        : state.dialogModal.onCancelHandler,
                    onConfirmHandler: action.payload.onConfirmHandler
                        ? action.payload.onConfirmHandler
                        : state.dialogModal.onConfirmHandler,
                },
            };
        case PAYMENTS.PAYMENT_INFO:
            return {
                ...state,
                paymentInfo: action.payload.payment,
            };
        case PAYMENTS.PAYMENT_DATA:
            return {
                ...state,
                paymentData: action.payload.paymentData,
            };
        case PAYMENTS.PAYMENT_INFO_DELETE:
            return {
                ...state,
                paymentInfo: undefined,
                paymentData: undefined,
            };
        case CREDIT.CREDIT_DETAIL:
            return {
                ...state,
                creditDetailData: action.payload.creditDetail,
            };
        case CREDIT.CREDIT_DETAIL_DELETE: {
            return {
                ...state,
                creditDetailData: undefined,
            };
        }
        case CREDIT_FORM_TOUCH_ACTIONS.MARK_CREDIT_FORM_TOUCHED:
            return {
                ...state,
                isCreditFormTouched: true,
            };
        case CREDIT_FORM_TOUCH_ACTIONS.MARK_CREDIT_FORM_UNTOUCHED:
            return {
                ...state,
                isCreditFormTouched: false,
            };
        case DEALER_ADMIN.DEALER_ADMIN_USER_SEARCH:
            return {
                ...state,
                dsmSearch: {
                    searchType: action.payload.searchType ?? Types.UserId,
                    searchValue: action.payload.searchValue ?? '',
                    users: action.payload.users ?? [],
                    selectedUsers: [],
                    actionType: '',
                },
            };
        case DEALER_ADMIN.DEALER_ADMIN_USER_ADD_SELECTED:
            return {
                ...state,
                dsmSearch: {
                    ...state.dsmSearch,
                    selectedUsers: action.payload.selectedUsers ?? [],
                    actionType: '',
                },
            };
        case DEALER_ADMIN.DEALER_ADMIN_USER_DELETE:
            return {
                ...state,
                dsmSearch: {
                    ...state.dsmSearch,
                    actionType: actionTypes.Delete,
                },
            };
        case DEALER_ADMIN.DEALER_ADMIN_USER_MIGRATION:
            return {
                ...state,
                dsmSearch: {
                    ...state.dsmSearch,
                    actionType: actionTypes.Migrate,
                },
            };
        case DEALER_ADMIN.SET_DEALER_GROUP_DATA:
            sessionStorage.setItem(
                'dealerGroupState',
                JSON.stringify(action.payload.dealerGroupState),
            );
            return {
                ...state,
                dealerGroupState: action.payload.dealerGroupState,
            };
        default:
            return state;
    }
};

const userStore = legacy_createStore(userReducer);

function getDialog(state: IUser) {
    return {
        isModalActive: state.dialogModal
            ? state.dialogModal.isModalActive
            : false,
        shouldShow: state.dialogModal ? state.dialogModal.shouldShow : false,
        titleContent: state.dialogModal ? state.dialogModal.titleContent : '',
        bodyContent: state.dialogModal ? state.dialogModal.bodyContent : '',
        cancelBtnLabel: state.dialogModal
            ? state.dialogModal.cancelBtnLabel
            : '',
        confirmBtnLabel: state.dialogModal
            ? state.dialogModal.confirmBtnLabel
            : '',
        onCancelHandler: state.dialogModal
            ? state.dialogModal.onCancelHandler
            : () => false,
        onConfirmHandler: state.dialogModal
            ? state.dialogModal.onConfirmHandler
            : () => false,
    };
}

export default userStore;
